



































import { Vue, Prop, Component } from "vue-property-decorator";
import { VueEditor, Quill } from "vue2-editor";
import { IndentStyle, AlignStyle } from "./RichTextEditorStyleModifier";

//these registers make quill, that is at the base of this text editor, use inline style instead of quill classes
Quill.register(IndentStyle, true);
Quill.register(AlignStyle, true);

// use div tag to wrap text by default - reason = it is more consistent
// and <p> has a nasty botton margin that is ugly
const Block = Quill.import('blots/block');
Block.tagName = 'DIV';
Quill.register(Block, true);

const sizeStyle = Quill.import('attributors/style/size')

//sizes for all 6 html header tags that were previously available to pick (16px - normalText/h4)
sizeStyle.whitelist = [ '32px', '24px', '18.7px', '16px', '14px', '12px']
Quill.register(sizeStyle, true);

@Component({
  components: {
    VueEditor,
  },
})
export default class RichTextEditor extends Vue {
  @Prop() value?: string;
  @Prop({ default: false }) disabled?: boolean;
  @Prop({ default: "1" }) id?: string;
  @Prop({ default: "" }) placeholderText?: string;
  @Prop() editorToolbar?: any[];
  @Prop({ default: () => [] }) rules?: any[];
  @Prop() label?: string;
  @Prop({ default: false }) outlined?: boolean;

  errors: any[] = [];

  mounted() {
    const rte = this.$refs.rte as Vue;
    const arr = [].slice.call(rte.$el.children[0].children);
    const buttons = arr.flatMap((x: any) => [].slice.call(x.children));
    buttons
      .filter((x: any) => x.type == "button" || x.tagName == "SPAN")
      .forEach((x: any) => {
        let tool = x.className.replace("ql-", "") as string;
        if (x.value) tool += "_" + x.value;

        const tooltip = this.tooltips.find((x) => x.key === tool);
        if (tooltip) x.title = tooltip.value;
      });
  }

  tooltips = [
    { key: "bold", value: this.$t('Bold') },
    { key: "italic", value: this.$t('Italic') },
    { key: "underline", value: this.$t('Underline') },
    { key: "strike", value: this.$t('Strikethrough') },
    { key: "align", value: this.$t('Align left') },
    { key: "align_center", value: this.$t('Align center') },
    { key: "align_right", value: this.$t('Align right') },
    { key: "align_justify", value: this.$t('Align justify') },
    { key: "blockquote", value: this.$t('Blockquote') },
    { key: "code-block", value: this.$t('Code block') },
    { key: "list_ordered", value: this.$t('List ordered') },
    { key: "list_bullet", value: this.$t('List bullet') },
    { key: "list_check", value: this.$t('List check') },
    { key: "indent_-1", value: this.$t('Indent -') },
    { key: "indent_+1", value: this.$t('Indent +') },
    { key: "color ql-picker ql-color-picker", value: this.$t('Color picker') },
    { key: "background ql-picker ql-color-picker", value: this.$t('Background color picker') },
    { key: "link", value: this.$t('Link') },
    { key: "clean", value: this.$t('Clean') },
  ];

  checkForErrors() {
    const textComponent = this.$refs.editor as any;
    this.errors = textComponent.errorBucket;
    this.$emit("errors", this.errors);
  }

  get isValid() {
    return this.errors.length > 0 ? false : true;
  }

  get internalModel() {
    return this.value ?? "";
  }

  set internalModel(val: string) {
    this.checkForErrors();
    this.$emit("input", val);
  }

  get toolbar() {
    return this.editorToolbar === undefined
      ? this.defaultToolbar
      : this.editorToolbar;
  }

  defaultToolbar = [
    //editors default value is first choice in select - thats why 'normal' is first
    [{'size': [ '16px', '32px', '24px', '18.7px', '14px', '12px' ]}], 
    ["bold", "italic", "underline", "strike"], // toggled buttons
    [
      { align: "" },
      { align: "center" },
      { align: "right" },
      { align: "justify" },
    ],
    ["blockquote", "code-block"],
    [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
    [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
    [{ color: [] }, { background: [] }], // dropdown with defaults from theme
    ["link"], // removed video and picture because we dont support that
    ["clean"], // remove formatting button
  ];
}
